import { render, staticRenderFns } from "./YearlySales.vue?vue&type=template&id=2efc73ec&"
import script from "./YearlySales.vue?vue&type=script&lang=js&"
export * from "./YearlySales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports